<template>
  <div class="ai-play-unsolicited-effect">
    <unsolicited-items
      :emitter="emitter"
      :items="emitter.caseConf.dialogue.aiUnsolicited"
      :selected="state.effect.id"
      :control="control"
      :readonly="readonly"
      placeholder="Say This"
      @update="selectUnsolicited"
    />
  </div>
</template>

<script>
import UnsolicitedItems from './UnsolicitedItems.vue';

export default {
  name: 'ai-play-unsolicited-effect',
  components: {
    UnsolicitedItems,
  },
  props: ['readonly', 'emitter', 'ikey', 'getData', 'putData', 'control'],
  data() {
    return {
      state: {
        effect: {},
      },
    };
  },
  mounted() {
    this.syncState();
    this.emitter.on('process', (nodeOrControl) => {
      // Update internal state when the node data changes
      // outside (e.g. from a CallAction)
      if (nodeOrControl === this.control) {
        this.syncState();
      }
    });
    this.emitter.trigger('process', this.control);
  },
  methods: {
    syncState() {
      this.state.effect = this.getData(this.ikey) || {};
    },
    selectUnsolicited(unsolicitedId) {
      this.state.effect.id = unsolicitedId;
      this.update();
    },
    update() {
      this.putData(this.ikey, { type: 'AI_UNSOLICITED_DIALOGUE', ...this.state.effect });
      this.emitter.trigger('process', this.control);
      this.$forceUpdate();
    },
  },
}
</script>

<style scoped>

</style>